'use strict'

import ApiClient from './ApiClient'
import qs from 'qs'

export default class ExlocationRepository {
  /**
   * 交換場所一覧取得
   * @param params
   * @returns {*}
   */
  getList (params) {
    return ApiClient().get(`/exlocations`, { params })
  }

  /**
   * 交換場所情報取得
   * @param id ID
   * @returns {*}
   */
  get (id) {
    return ApiClient().get(`/exlocations/${id}`)
  }

  /**
   * 交換場所作成
   * @param data 登録値
   * @returns {*}
   */
  post (data) {
    return ApiClient().post(`/exlocations`, qs.stringify(data))
  }

  /**
   * 交換場所更新
   * @param id id
   * @param params 登録値
   * @returns {*}
   */
  put (id, params) {
    return ApiClient().put(`/exlocations/${id}`, qs.stringify(params))
  }

  /**
   * 交換場所削除
   * @param id id
   * @returns {*}
   */
  delete (id) {
    return ApiClient().delete(`/exlocations/${id}`)
  }

  /**
   * 指定された複数IDの交換場所情報を一括削除します。
   * @param {object} data
   * @returns {*}
   */
  bulkDelete (data) {
    return ApiClient().post(`/exlocations/delete`, data)
  }

  /**
   * 選択された複数IDの表示順を別の場所に移動します
   * @param {object} params
   * @returns {*}
   */
  sort (params) {
    return ApiClient().put(`/exlocations/sort`, params)
  }

  /**
   * 選択用交換場所情報一覧を取得
   * @returns {*}
   */
  getChoices () {
    return ApiClient().get(`/exlocations/choices`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/ExlocationRepository.js